import React from 'react';

const ListingFormFields = ({ formData, categories, handleChange, handleEmailValidation }) => {
  return (
    <>
      <div>
        <label className="block text-gray-700 mb-2">Site Name</label>
        <input
          type="text"
          name="name"
          className="w-full px-3 py-2 border rounded-lg"
          value={formData.name}
          onChange={handleChange}
        />
      </div>

      <div>
        <label className="block text-gray-700 mb-2">Description</label>
        <textarea
          name="description"
          className="w-full px-3 py-2 border rounded-lg"
          rows="4"
          value={formData.description}
          onChange={handleChange}
        />
      </div>

      <div>
        <label className="block text-gray-700 mb-2">Email</label>
        <input
          type="email"
          name="email"
          className="w-full px-3 py-2 border rounded-lg"
          value={formData.email}
          onChange={handleChange}
          onBlur={handleEmailValidation}
        />
      </div>

      <div>
        <label className="block text-gray-700 mb-2">Category</label>
        <select
          name="category"
          className="w-full px-3 py-2 border rounded-lg"
          value={formData.category}
          onChange={handleChange}
        >
          {categories.map(category => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-gray-700 mb-2">Image URL</label>
        <input
          type="url"
          name="image"
          className="w-full px-3 py-2 border rounded-lg"
          value={formData.image}
          onChange={handleChange}
          placeholder="URL to site's main image"
        />
      </div>

      <div>
        <label className="block text-gray-700 mb-2">Location</label>
        <input
          type="text"
          name="location"
          className="w-full px-3 py-2 border rounded-lg"
          value={formData.location}
          onChange={handleChange}
          placeholder="Physical location or service area"
        />
      </div>
    </>
  );
};

export default ListingFormFields;
